// Mock statement module (spec §11.2): every credit and debit on the account.
import type { StatementEntry } from '@/types/phase2.types';
import { loadDb } from '../db';
import { pause } from '../util';

export const listStatement = async (): Promise<StatementEntry[]> => {
  await pause(400);
  return [...loadDb().ledger];
};
